"use strict";
import _ from "lodash";

const Nav = () => {
    const init = () => {
        let $navbar = $('.navbar-collapse');
        $('header .hamburger').click(function() {
            if ($(this).hasClass('is-active')) {
                $(this).removeClass('is-active');
                $navbar.removeClass('show');
                $('.show-secondary').removeClass('show-secondary');
            } else {
                $(this).addClass('is-active');
                $navbar.addClass('show');
            }
        });

        $('header .navbar-collapse.mobile .nav-item.dropdown').click(function() {
            let $this = $(this);
            if (!$this.hasClass('is-active')) {
                $this.addClass('is-active');
                $this.addClass('show-secondary');
            }
        });
        $('header .navbar-collapse.mobile .nav-item.dropdown .top').click(function(e) {
            e.preventDefault();
            e.stopPropagation();

            let $this = $(this).parents('.nav-item.dropdown');
            $this.removeClass('is-active');
            $this.removeClass('show-secondary');
        });

        $(window).on('scroll', _.debounce(onScroll, 400));
        onScroll();

        // Add class if secondary nav is active
        if ($('.nav-item.dropdown.active')[0]) {
            document.body.className += ' secondary-active';
        }

        // Handle nav hovers, need to hide static/active subnavs on hover
        $('nav .navbar-nav > .nav-item.dropdown').hover(function() {
            // On hover
            let $this = $(this);

            if (!$this.hasClass('active')) {
                $('.nav-item.active').addClass('hide-active');
            }
        }, function() {
            // On out
            $('.hide-active').removeClass('hide-active');
        });

        let $stickyNav = $('#sticky-nav');
        if ($stickyNav[0]) {
            $('body').addClass('has-sticky-nav');
        }
        $stickyNav.on('change', 'select', function() {
            window.location = $(this).val();
        });
    };

    const onScroll = function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 5) {
            $("nav.navbar").addClass("slim");
            $('body').addClass("slim-nav");
        } else {
            $("nav.navbar").removeClass("slim");
            $('body').removeClass("slim-nav");
        }
    };

    return {
        init:init
    };
};

export default Nav;